<div class="tw-pb-6 tw-rounded-3 tw-overflow-visible" [class]="isHairRegimen ? 'tw-bg-purple-75' : 'tw-bg-yellow-75'" (click)="onBuyNow()">
  <div class="tw-flex tw-items-start tw-relative">
    <div class="tw-pl-4 tw-pt-[5.5%] tw-flex-[3_0_60%]">
      @if (bannerDetail()?.regimenClass === ApiClientConstant.Regimen.Class.FACE) {
        <p class="tw-font-lexend tw-font-bold tw-text-500 tw-leading-[21px] tw-text-gray-900 tw-capitalize" i18n="@@getYourCompleteSkinKit">
          Get your Complete skin kit
        </p>
      }
      @if (bannerDetail()?.regimenClass === ApiClientConstant.Regimen.Class.HAIR) {
        <p class="tw-font-lexend tw-font-bold tw-text-500 tw-leading-[21px] tw-text-gray-900 tw-capitalize" i18n="@@getYourCompleteHairKit">
          Get your Complete hair kit
        </p>
      }
      <div class="tw-flex tw-items-start tw-gap-1 tw-mt-1">
        <span
          class="tw-inline-block tw-w-2 tw-h-2 tw-mt-[3px] tw-rounded-full tw-shrink-0 tw-bg-orange-400">
        </span>

        @if (isUpdatedToday) {
          <p i18n="@@regimenReorderUpdatedToday"
             class="tw-text-50 tw-leading-[14px] tw-uppercase tw-tracking-[0.8px] tw-text-gray-500 tw-font-normal">
            updated today by <span class="tw-whitespace-nowrap">{{ doctorFirstName }}</span>
          </p>
        }
        @if (isUpdatedYesterday) {
          <p i18n="@@regimenReorderUpdatedYesterday"
             class="tw-text-50 tw-leading-[14px] tw-uppercase tw-tracking-[0.8px] tw-text-gray-500 tw-font-normal">
            updated yesterday by <span class="tw-whitespace-nowrap">{{ doctorFirstName }}</span>
          </p>
        }
        @if (isUpdatedBeforeYesterday) {
          <p i18n="@@regimenReorderUpdatedOnDate"
             class="tw-text-50 tw-leading-[14px] tw-uppercase tw-tracking-[0.8px] tw-text-gray-500 tw-font-normal">
            updated on {{ lastUpdatedAtDate | date:'d MMM' }} by <span class="tw-whitespace-nowrap">{{ doctorFirstName }}</span>
          </p>
        }
      </div>
    </div>

    <div class="tw-flex-[2_0_40%] tw-flex tw-items-end tw-z-[9]">
      <img
        class="tw-w-full tw-h-auto tw-object-contain"
        [src]="bannerKitImage"
        alt="doctor holding kit"
      />
    </div>
    <div class="tw-absolute tw-left-4 tw-right-0 tw-w-[58%] tw-h-px tw-bg-gray-200 tw-bottom-[17%] xxxs:tw-bottom-[20%] xxs:tw-bottom-[23%]"></div>

  </div>

  <!-- PRODUCTS STRIP -->
  <div class="tw-flex tw-items-center tw-justify-around -tw-mt-5 tw-px-4 tw-gap-1 tw-overflow-x-auto tw-overflow-y-hidden tw-h-[160px]">
    @for (product of bannerDetail()?.products; track product.title; let last = $last) {
      <div class="tw-flex tw-flex-col tw-items-center tw-shrink-0" style="width: 60px; gap: 6px;">
        <div class="tw-h-[122px] tw-w-full tw-flex tw-items-end tw-justify-center tw-overflow-hidden">
          <img
            [src]="product.image"
            [alt]="product.title"
            class="tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-object-contain"
          />
        </div>
        <p class="tw-text-[8px] tw-text-black tw-text-center tw-leading-[10px] tw-w-full">
          {{ product.title }}
        </p>
      </div>

      @if (!last) {
        <span class="tw-text-[16px] tw-font-medium tw-text-black tw-shrink-0 tw-leading-none">+</span>
      }
    }
  </div>

  <!-- CTA BUTTON -->
  <div class="tw-px-4 tw-pt-4">
    <button
      csButton
      type="button"
      class="tw-w-full tw-relative tw-flex tw-items-center tw-justify-between tw-max-h-10 tw-text-400"
    >
      <span class="tw-flex-1">
        <span i18n="@@buyNow">Buy Now</span> &#64;
        <span class="tw-font-normal tw-text-200 tw-line-through">₹{{ bannerDetail()?.totalMrp }}</span>
        <span>₹{{ bannerDetail()?.totalSP }}</span>
      </span>

      <span
        class="tw-h-4 tw-w-14 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-font-bold tw-text-50 tw-text-white"
        style="background-color: #cc6b31;">
        {{ bannerDetail()?.discountInPercentage }}% OFF
      </span>
    </button>
  </div>

</div>
